/**
 * Helper class to manage user caching for CircleService
 */
class CacheHelper {
    constructor() {
        this.userCache = new Map();
        this.cacheTimeout = 5 * 60 * 1000; // 5 minutes
    }

    /**
     * Clears the entire user cache
     */
    clearCache() {
        this.userCache.clear();
    }

    /**
     * Retrieves a cached user if available and not expired
     * @param {number|string} userId - The user ID to retrieve
     * @returns {Object|null} The cached user data or null if not found/expired
     */
    getCachedUser(userId) {
        const cached = this.userCache.get(userId);
        if (!cached) return null;
        
        // Check if cache has expired
        if (Date.now() - cached.timestamp > this.cacheTimeout) {
            this.userCache.delete(userId);
            return null;
        }
        
        return cached.data;
    }

    /**
     * Stores user data in the cache
     * @param {number|string} userId - The user ID to cache
     * @param {Object} userData - The user data to store
     */
    setCachedUser(userId, userData) {
        this.userCache.set(userId, {
            data: userData,
            timestamp: Date.now()
        });
    }
}

export default new CacheHelper(); 